import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import Card from "components/card";

Chart.register(ArcElement, Tooltip, Legend);

const ReportPieChart = ({ pieInfo }) => {
  if (!pieInfo || pieInfo.length === 0) return <div>Loading...</div>;

  return (
    <div
      className="grid gap-5"
      style={{
        gridTemplateColumns: `repeat(${Math.min(
          pieInfo.length,
          4
        )}, minmax(0, 1fr))`,
      }}
    >
      {pieInfo.map((chartData, index) => {
        const data = {
          labels: chartData.plotData.map((item) => item.category),
          datasets: [
            {
              label: chartData.PieChartName,
              data: chartData.plotData.map((item) => item.value),
              backgroundColor: [
                "#42AACC",
                "#EE5D50",
                "#4299e1",
                "#A3AED0",
                "#D69E2E",
                "#809D3C",
                "#A35C7A",
              ],
              borderWidth: 1,
            },
          ],
        };

        return (
          <Card key={index} extra="rounded-[20px] p-3 h-[450px] relative">
            <div className="flex flex-row justify-between px-3 pt-2">
              <div>
                <h4 className="text-lg font-bold text-navy-700 dark:text-white">
                  {chartData.PieChartName}
                </h4>
              </div>
            </div>

            <div
              className="mb-auto flex h-[380px] w-full items-center justify-center"
              style={{
                maxHeight: "300px",
                maxWidth: "100%",
                marginTop: "20px",
              }}
            >
              <Pie
                data={data}
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      display: true,
                      position: "bottom",
                    },
                  },
                }}
              />
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default ReportPieChart;
